import React from 'react';
import LinearProgress from 'material-ui/LinearProgress';
import CircularProgress from 'material-ui/CircularProgress';
import conf from 'config/app-config';

const style = {
    circularLoader: {
        display: 'inline-block',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60px',
        zIndex: 1
    },
    linearLoader: {
        display: 'inline-block',
        position: 'absolute',
        top: '5%',
        left: '50%',
        transform: 'translate(-50%)',
        width: '95%',
        zIndex: 1
    },
    percent: {
        color: 'white',
        textShadow: 'rgb(56, 48, 48) 1px 1px 4px'
    }
};

const WochitProgress = (props) => {
    let progress;
    const color = conf.loaderColors[props.uploadStatus || 'INIT'];

    let circularLoaderStyle = style.circularLoader;

    if (props.width) {
        circularLoaderStyle = Object.assign({}, circularLoaderStyle, { width: props.width});
    }

    if (props.uploadStatus === 'FAILED' || props.uploadStatus === 'DONE') {
        progress = null;
    } else {
        const percentComplete = props.percentComplete || 0;
        const value = Math.max(percentComplete, 5);
        const determinate = <div style={style.linearLoader}><LinearProgress size={60} mode='determinate' value={value}
                                                                            color={color}/><span style={style.percent}>{value + '%'}</span></div>;
        const indeterminate = <CircularProgress size={60} style={circularLoaderStyle} color={color}/>;
        progress = (props.fileSize < 2 ** 20 * 5 || props.uploadStatus === 'PROCESSING') ? indeterminate : determinate;
    }

    return progress;
};

export default WochitProgress;